import { Route, Routes, Link } from "react-router";
import { PublicHome } from "./routes/public/PublicHome";
import { ArchivePage } from "./routes/public/ArchivePage";
import { AdminLogin } from "./routes/admin/AdminLogin";
import { AdminVerify } from "./routes/admin/AdminVerify";
import { AdminDashboard } from "./routes/admin/AdminDashboard";
import { OpenIncident } from "./routes/admin/OpenIncident";
import { Wordmark } from "./components/Wordmark";

export function App() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      <header className="bg-white shadow-sm">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Wordmark />
            <nav aria-label="primary" className="flex items-center gap-5 text-sm">
              <Link
                to="/archive"
                className="text-gray-500 hover:text-gray-900"
              >
                Incident archive
              </Link>
              <a
                href="/v1/feed.xml"
                className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-gray-700 hover:bg-gray-50"
              >
                <svg
                  aria-hidden="true"
                  className="h-4 w-4 text-primary-500"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M6.18 15.64a2.18 2.18 0 1 1 0 4.36 2.18 2.18 0 0 1 0-4.36zM4 4.44A15.56 15.56 0 0 1 19.56 20h-2.83A12.73 12.73 0 0 0 4 7.27V4.44zm0 5.66a9.9 9.9 0 0 1 9.9 9.9h-2.83A7.07 7.07 0 0 0 4 12.93V10.1z" />
                </svg>
                Atom feed
              </a>
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1 bg-slate-50">
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/verify" element={<AdminVerify />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/incidents/new" element={<OpenIncident />} />
        </Routes>
      </main>

      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
            <div className="col-span-2 md:col-span-1">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-600">
                Retrieve<span className="text-primary-500">IT</span>.AI
              </h3>
              <p className="mt-3 text-sm text-gray-500">
                Unified Knowledge Search for Your Enterprise.
              </p>
            </div>
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-600">
                Status
              </h3>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  <Link to="/" className="text-gray-500 hover:text-gray-900">
                    Current status
                  </Link>
                </li>
                <li>
                  <Link
                    to="/archive"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Incident archive
                  </Link>
                </li>
                <li>
                  <a
                    href="/v1/feed.xml"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Atom / RSS feed
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-600">
                Product
              </h3>
              <ul className="mt-3 space-y-2 text-sm">
                <li>
                  <a
                    href="https://retrieveit.ai/"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    RetrieveIT.AI
                  </a>
                </li>
                <li>
                  <a
                    href="https://app.retrieveit.ai/"
                    className="text-gray-500 hover:text-gray-900"
                  >
                    Sign in to the app
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-600">
                Subscribe
              </h3>
              <p className="mt-3 text-sm text-gray-500">
                Point any RSS reader or RSS-to-Slack bridge at{" "}
                <a
                  href="/v1/feed.xml"
                  className="text-primary-600 underline decoration-primary-200 underline-offset-2 hover:text-primary-700"
                >
                  /v1/feed.xml
                </a>{" "}
                to get updates.
              </p>
            </div>
          </div>
          <div className="mt-10 border-t border-gray-200 pt-6">
            <p className="text-center text-xs text-gray-400">
              &copy; {new Date().getFullYear()} OutcomeOps LLC. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
